import { localEventDayKey } from "@/lib/agendaEventRange";

export interface AgendaDates {
  start_at: string;
  end_at?: string | null;
  all_day_start?: string | null;
  all_day_end?: string | null;
}

export function isAllDay(event: AgendaDates | null | undefined): event is AgendaDates & { all_day_start: string; all_day_end: string } {
  return !!event?.all_day_start && !!event.all_day_end && event.all_day_end > event.all_day_start;
}

export function eventStartDate(event: AgendaDates): Date {
  return new Date(isAllDay(event) ? event.all_day_start + "T00:00:00" : event.start_at);
}

export function eventOccursOn(event: AgendaDates, day: Date): boolean {
  const key = localEventDayKey(day.toISOString());
  return isAllDay(event) ? event.all_day_start! <= key && key < event.all_day_end! : localEventDayKey(event.start_at) === key;
}

/** Both ranges are half-open. Timed events retain their existing start-day scope. */
export function agendaRangeFilter(start: Date, end: Date): string {
  return `and(all_day_start.is.null,start_at.gte.${start.toISOString()},start_at.lt.${end.toISOString()}),and(all_day_start.lt.${localEventDayKey(end.toISOString())},all_day_end.gt.${localEventDayKey(start.toISOString())})`;
}

export function formatAllDayDates(event: AgendaDates, locale: string): string {
  const first = eventStartDate(event);
  const last = new Date(event.all_day_end + "T00:00:00");
  last.setDate(last.getDate() - 1); // Google end.date is exclusive.
  const opts: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric" };
  return first.getTime() === last.getTime() ? first.toLocaleDateString(locale, opts)
    : `${first.toLocaleDateString(locale, opts)} – ${last.toLocaleDateString(locale, opts)}`;
}
